module.exports = __webpack_public_path__ + "img/banner.3f35e908.jpg";